/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-11-06 16:29:48
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-10 11:03:14
 * @FilePath: \senlan-ai-ui\src\config\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
/**
 * @description 配置应用程序的常量,一般用于统一管理应用程序的变量
 */

// 首页的路径
export const HOME_PATH: string = '/chat'

// 登录页的路径
export const LOGIN_PATH: string = '/login'

// 路由白名单（也指静态路由）
export const WHITE_LIST: string[] = ['/403', '/404', '/500']
